//@ts-nocheck
// import React from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

// const RevenueChart = ({ stagesByBucket }) => {
//   // Prepare data for the chart
//   const prepareChartData = () => {
//     if (!stagesByBucket || Object.keys(stagesByBucket).length === 0) {
//       return [];
//     }
//     const chartData = [];

//     // Process each bucket (inbox, screening, hired, reject)
//     Object.keys(stagesByBucket).forEach(bucketKey => {
//       const bucket = stagesByBucket[bucketKey];

//       // Process each stage within the bucket
//       if (bucket.stages && bucket.stages.length > 0) {
//         bucket.stages.forEach(stage => {            
//           chartData.push({
//             name: stage.stage_name,
//             applications: stage.applications,
//             maidenTime: parseFloat(stage.maidenTime.toFixed(1)),
//             bucket: bucket.name.charAt(0).toUpperCase() + bucket.name.slice(1), // Capitalize bucket name
//             stageColor: stage.stage_colour || getBucketColor(bucket.name) // Use stage color or fallback to bucket color
//           });
//         });
//       }
//     });

//     return chartData;
//   };

//   // Helper function to get bucket colors
//   const getBucketColor = (bucketName) => {
//     const colorMap = {
//       'inbox': '#4F46E5',
//       'screening': '#10B981',
//       'hired': '#06B6D4',
//       'reject': '#EF4444'
//     };
//     return colorMap[bucketName.toLowerCase()] || '#8884d8'; // Default color if bucket not found
//   };

//   const data = prepareChartData();


//   // Custom tooltip to show both applications and time
//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div className="bg-white p-2 border border-gray-200 shadow-md rounded-md">
//           <p className="font-semibold">{`${label} (${payload[0]?.payload.bucket})`}</p>
//           <p className="text-sm">{`Applications: ${payload[0]?.value}`}</p>
//           <p className="text-sm">{`Average Time: ${payload[1]?.value} hours`}</p>
//         </div>
//       );
//     }
//     return null;
//   };

//   // If no data, show a message
//   if (data.length === 0) {
//     return <div className="text-center p-6 text-gray-500">No stage data available</div>;
//   }

//   return (
//     <div style={{ width: '100%', height: 400 }}>
//       <ResponsiveContainer>
//         <BarChart
//           data={data}
//           margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis 
//             dataKey="name" 
//             angle={-45} 
//             textAnchor="end" 
//             height={80}
//             tick={{ fontSize: 12 }}
//           />
//           <YAxis yAxisId="left" orientation="left" stroke="#8884d8" />
//           <YAxis yAxisId="right" orientation="right" stroke="#FF8042" />
//           <Tooltip content={<CustomTooltip />} />
//           <Legend />
//           <Bar 
//             yAxisId="left" 
//             dataKey="applications" 
//             name="Applications" 
//             radius={[4, 4, 0, 0]}
//           >
//             {data.map((entry, index) => (
//               <Cell key={`cell-${index}`} fill={entry.stageColor || '#8884d8'} />
//             ))}
//           </Bar>
//           <Bar 
//             yAxisId="right" 
//             dataKey="maidenTime" 
//             name="Average Time (days)" 
//             radius={[4, 4, 0, 0]}
//           >
//             {data.map((entry, index) => (
//               <Cell key={`cell-${index}`} fill={entry.stageColor || '#FF8042'} />
//             ))}
//           </Bar>
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default RevenueChart;


import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const RecruitmentCharts = ({ stagesByBucket }) => {


  // Prepare data for the charts
  const prepareChartData = (stagesByBucket) => {
    if (!stagesByBucket || Object.keys(stagesByBucket).length === 0) {
      return [];
    }

    const chartData = [];

    // Process each bucket (inbox, screening, hired, reject)
    Object.keys(stagesByBucket).forEach(bucketKey => {
      const bucket = stagesByBucket[bucketKey];

      // Process each stage within the bucket
      if (bucket.stages && bucket.stages.length > 0) {
        bucket.stages.forEach(stage => {
          const displayName = `${stage.stage_name}`;

          // Create chart data entry
          const dataEntry = {
            name: displayName,
            stageId: stage.id,
            currentCount: stage.currentCount,
            maidenTime: parseFloat(stage.maidenTime.toFixed(1)),
            bucket: bucket.name.charAt(0).toUpperCase() + bucket.name.slice(1), // Capitalize bucket name
            color: stage.stage_colour || getBucketColor(bucket.name) // Use stage color or fallback to bucket color
          };

          // Add previousCount only if it's not null
          if (stage.previousCount !== null) {
            dataEntry.previousCount = stage.previousCount;
          }

          chartData.push(dataEntry);
        });
      }

    });

    return chartData;
  };

  // Helper function to get bucket colors
  const getBucketColor = (bucketName) => {
    const colorMap = {
      'inbox': '#4F46E5',
      'screening': '#10B981',
      'hired': '#06B6D4',
      'reject': '#EF4444'
    };
    return colorMap[bucketName.toLowerCase()] || '#8884d8'; // Default color if bucket not found
  };

  const data = prepareChartData(stagesByBucket);

  // Custom tooltip for Applications chart
  const ApplicationsTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white dashboard-card border-light-gray-200 border-solid border rounded-md">
          <p className="font-medium pt-[6px] px-3 pb-[6px]">{label}</p>
          <div className='bg-[#e0e0e0] w-full h-[1px] my-0'></div>
          {payload.length > 1 && payload[1]?.value !== undefined && (
            <p className="text-sm px-3 pb-2 pt-[6px]">{`Previous: ${payload[1]?.value}`}</p>
          )}
          <p className="text-sm px-3 pb-2 pt-[0px]">{`Current: ${payload[0]?.value}`}</p>
     
        </div>
      );
    }
    return null;
  };


  // Custom tooltip for Maiden Time chart
  const TimeTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white dashboard-card border-light-gray-200 border-solid border rounded-md">
          <p className="font-medium pt-[6px] px-3 pb-[6px]">{label}</p>
          <div className='bg-[#e0e0e0] w-full h-[1px] my-0'></div>
          <p className="text-sm px-3 pb-2 pt-[6px]">{`Average Time: ${payload[0]?.value} hours`}</p>
        </div>
      );
    }
    return null;
  };

  // If no data, show a message
  if (data.length === 0) {
    return <div className="text-center p-6 text-gray-500">No stage data available</div>;
  }

  return (
    <div className="w-full flex items-center gap-4 flex-wrap lg:flex-nowrap">
      <div className="bg-[#f9fafa] dashboard-card border-light-gray-200 border-solid border rounded-md min-h-full p-5  w-full lg:w-[50%]">
        <h2 className="text-sm leading-3 font-[500] text-dark-black-100 flex items-center gap-[6px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
            data-slot="icon"
            className="w-4 h-4 text-dark-black-100 "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"
            />
          </svg>
          Applications by Stage
        </h2>

        <div style={{ width: '100%', height: 300 }} className='mt-10'>
          <ResponsiveContainer>
            <BarChart
              data={data}
              margin={{ top: 20, right: 20, left: -20, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                textAnchor="middle"
                height={80}
                tick={{ fontSize: 12, fontFamily: 'Inter, sans-serif' }}
              />
              <YAxis />
              <Tooltip content={<ApplicationsTooltip />} />
              <Legend />
              {
                data.some(entry => entry.previousCount !== undefined) &&
                <Bar
                  dataKey="previousCount"
                  name="Previous Applications"
                  radius={[4, 4, 0, 0]}
                  stackId="a"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-previous-${index}`} fill={entry.color} fillOpacity={0.5} />
                  ))}
                </Bar>
              }
              <Bar
                dataKey="currentCount"
                name="Current Applications"
                radius={[4, 4, 0, 0]}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-current-${index}`} fill={entry.color} />
                ))}
              </Bar>
            
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="bg-[#f9fafa] dashboard-card border-light-gray-200 border-solid border rounded-md min-h-full p-5  w-full lg:w-[50%]">

        <h4 className="text-sm leading-3 font-[500] text-dark-black-100 flex items-center gap-[6px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
            data-slot="icon"
            className="w-4 h-4 text-dark-black-100 "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
            />
          </svg>
          Average Time by Stage (hours)
        </h4>

        <div style={{ width: '100%', height: 300 }} className='mt-10'>
          <ResponsiveContainer>
            <BarChart
              data={data}
              margin={{ top: 20, right: 20, left: -20, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                // angle={-45}
                textAnchor="middle"
                height={80}
                tick={{ fontSize: 12, fontFamily: 'Inter, sans-serif' }}
              />
              <YAxis />
              <Tooltip content={<TimeTooltip />} />
              <Legend />
              <Bar
                dataKey="maidenTime"
                name="Average Time (hours)"
                radius={[4, 4, 0, 0]}
                fill="#FF8042"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-time-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default RecruitmentCharts;